// MoamadsBetweenDatesContext.js
import React, { createContext, useContext, useState } from "react";

const MoamadsBetweenDatesContext = createContext();

export const MoamadsBetweenDatesProvider = ({ children }) => {
  const [moamadsBetweenDatesRep, setMoamadsBetweenDatesRep] = useState([]);

  const updateMoamadsBetweenDatesRep = (newMoamadsBetweenDatesRep) => {
    setMoamadsBetweenDatesRep(newMoamadsBetweenDatesRep);
  };

  return (
    <MoamadsBetweenDatesContext.Provider
      value={{ moamadsBetweenDatesRep, updateMoamadsBetweenDatesRep }}
    >
      {children}
    </MoamadsBetweenDatesContext.Provider>
  );
};

export const useMoamadsBetweenDatesContext = () => {
  return useContext(MoamadsBetweenDatesContext);
};
